import axios from 'axios';
// import Qs from 'qs'
import request from './request';
import router from '../router/router';
// import { baseUrl } from '../config'
// import ElementUI from 'element-ui';
axios.defaults.withCredentials = true;
export default class Net {
  static get(url, params) {
    return new Promise((resolve, reject) => {
      axios({
          method: 'get',
          url,
          params,
          headers: {
            Authorization: localStorage.getItem('token') ?
              JSON.parse(localStorage.getItem('token')) : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJYaWFvaGVpIiwiZXhwIjoxNjA3MjQ0NDg0LCJpYXQiOjE2MDQ1NjYwODQsImlzcyI6IkRhVG91TmV0Iiwic3ViIjoiRHRTaG9wIiwidWlkIjo0LCJhZ2VudCI6MX0.zHynm0bQMWLkhlXSYq_pCELWXSuDRZSFN1BbAaFjXBA'
          }
          // headers: { Authorization: '' }
        })
        .then((res) => {
          this.successTodo(resolve, reject, res);
        })
        .catch((error) => {
          this.errTodo(error, url);
        });
    });
  }

  static post(url, params) {
    return new Promise((resolve, reject) => {
      //   console.log(
      //     localStorage.getItem('token'),
      //     "localStorage.getItem('token')",
      //   )
      const headers =
        localStorage.getItem('token') ? {
          Authorization: JSON.parse(localStorage.getItem('token'))
        } : {
          Authorization: ''
        };
      axios({
          method: 'post',
          url,
          data: JSON.stringify(params),
          headers: headers
        })
        .then((res) => {
          this.successTodo(resolve, reject, res);
        })
        .catch((error) => {
          this.errTodo(error, url);
        });
    });
  }

  static put(url, params) {
    return new Promise((resolve, reject) => {
      //   console.log(
      //     localStorage.getItem('token'),
      //     "localStorage.getItem('token')",
      //   )
      const headers =
        localStorage.getItem('token') ? {
          Authorization: JSON.parse(localStorage.getItem('token'))
        } : {
          Authorization: ''
        };
      axios({
          method: 'put',
          url,
          data: JSON.stringify(params),
          headers: headers
        })
        .then((res) => {
          this.successTodo(resolve, reject, res);
        })
        .catch((error) => {
          this.errTodo(error, url);
        });
    });
  }

  static delete(url, params) {
    return new Promise((resolve, reject) => {
      //   console.log(
      //     localStorage.getItem('token'),
      //     "localStorage.getItem('token')",
      //   )
      const headers =
        localStorage.getItem('token') ? {
          Authorization: JSON.parse(localStorage.getItem('token'))
        } : {
          Authorization: ''
        };
      axios({
          method: 'delete',
          url,
          data: JSON.stringify(params),
          headers: headers
        })
        .then((res) => {
          this.successTodo(resolve, reject, res);
        })
        .catch((error) => {
          this.errTodo(error, url);
        });
    });
  }

  static upPic(url, params) {
    return new Promise((resolve, reject) => {
      axios({
          method: 'get',
          url,
          params: params,
          headers: {
            Authorization: localStorage.getItem('token') ?
              JSON.parse(localStorage.getItem('token')) : ''
          }
          // headers: { Authorization: '' }
        })
        .then((res) => {
          let retcode = parseInt(res.status);
          if (retcode === 200) {
            let data = res.data.data;
            let param = new FormData(); // 创建form对象
            param.append('key', data.dir); // 通过append向form对象添加数据
            param.append('OSSAccessKeyId', data.accessid);
            param.append('policy', data.policy);
            param.append('signature', data.signature);
            param.append('expire', data.expire);
            param.append('callback', data.callback);
            param.append('dir', 'admin/');
            param.append('file', params.file);
            // console.log(param.get('file')); //FormData私有类对象，访问不到，可以通过get判断值是否传进去
            let config = {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: localStorage.getItem('token') ?
                  JSON.parse(localStorage.getItem('token')) : ''
              }
            }; // 添加请求头
            axios
              .post(data.host, param, config)
              .then((res) => {
                resolve(data.host + '/' + res.data.url);
              })
              .catch(function (e) {});
          } else if (retcode === 1001) {
            router.push('/login');
            localStorage.removeItem('token');
            reject(res.data.msg);
          } else {
            reject(alert(res.data.msg));
          }
        })
        .catch((error) => {
          this.errTodo(error, url);
        });
    });
  }

  static upFile(url, params) {
    let param = new FormData(); // 创建form对象
    param.append('file', params.file);
    return new Promise((resolve, reject) => {
      axios
        .post(url, param, {
          headers: {
            Authorization: localStorage.getItem('token') ?
              JSON.parse(localStorage.getItem('token')) : '',
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((res) => {
          this.successTodo(resolve, reject, res);
        })
        .catch((error) => {
          this.errTodo(error, url);
        });
    });
  }

  // 处理异常方法
  static successTodo(resolve, reject, val) {
    let retcode = parseInt(val.data.code);
    if (retcode === 200) {
      resolve(val.data.data);
    } else if (retcode === 1001) {
      router.push('/login');
      localStorage.removeItem('token');
      reject(val.data.msg);
    } else {
      reject(val.data.msg);
    }
    //else if (retcode == 5012004) {
    //   router.push('/login');
    //   localStorage.removeItem('token');
    //   reject(val.data.msg);
    // } else if (retcode == 5001002) {
    //   router.push('/login');
    //   localStorage.removeItem('token');
    //   reject(val.data.msg);
    // } else if (retcode == 3001106) {
    //   reject(val.data.msg);
    // } else if (retcode == 3001100) {
    //   reject(val.data.msg);
    // } else if (retcode == 6000000) {
    //   // 权限不足抛异常
    //   reject(val.data.msg);
    // } else if (retcode >= 3001001 && retcode <= 3002000) {
    //   //   window.location.href = '/'
    //   reject(val.data.msg);
    // } else if (retcode >= 3002001 && retcode <= 3002999) {
    //   window.location.href = '/user';
    //   reject(val.data.msg);
    // } else {
    //   reject(val.data.msg);
    // }
    // console.log(val);
    // if (retcode === 200) {
    //   resolve(val.data.data);
    // } else {
    //   reject(val.data.msg);
    // }
  }

  // 处理异常方法
  static errTodo(error, url) {
    // 非jsexception接口报错，post后端记录
    // if (url.indexOf('jsexception') === -1) {
    //   request.post('/jsexception', error);
    // }
    console.log(error);
    let errorCode = error.response.status;
    let errorCodeFir = (error.response.status + ``).substr(0, 1);
    let msg = '';
    if (errorCodeFir === '3') {
      msg = `${errorCode}:请刷新重试!`;
      alert(msg);
    } else if (errorCodeFir === '4') {
      msg = `${errorCode}:请刷新重试!`;
      alert(msg);
    } else if (errorCodeFir === '5') {
      msg = `${errorCode}:请刷新重试!`;
      alert(msg);
    }
  }
}